import { Manager, Pinch, Pan, Tap } from 'hammerjs';

export default class ControlSurface {
	constructor(controller, canvas) {
		this.CONTROLLER = controller;
		this.CANVAS = canvas;

		// Mouse
		this.positionPreviousX = -1;
		this.positionPreviousY = -1;

		this.CANVAS.onmousedown = this.onMouseDown.bind(this);
		// this.CANVAS.onmouseup = this.onMouseUp.bind(this);
		this.CANVAS.ontouchstart = this.onTouchStart.bind(this);
		this.CANVAS.ontouchend = this.onTouchEnd.bind(this);
		this.CANVAS.onmousemove = this.onMouseMove.bind(this);
		this.CANVAS.onmouseleave = this.onMouseLeave.bind(this);

		// Wheel
		canvas.addEventListener('DOMMouseScroll', this.onWheel.bind(this), false); // For Firefox
		canvas.addEventListener('mousewheel', this.onWheel.bind(this), false); // Everyone else
		// this.CANVAS.onwheel = this.onWheel.bind(this);

		// Touch
		this.HAMMER = new Manager(this.CANVAS);
		this.HAMMER.add([
			new Pinch(),
			new Pan({ threshold: 5 }),
			new Tap({ event: 'singletap', threshold: 5 })
		]);

		this.HAMMER.on('pinchstart', this.onTouchPinchStart.bind(this));
		this.HAMMER.on('pinch', this.onTouchPinch.bind(this));
		this.HAMMER.on('pinchend', this.onTouchPinchEnd.bind(this));
		this.HAMMER.on('panstart', this.onTouchPanStart.bind(this));
		this.HAMMER.on('panmove', this.onTouchPanMove.bind(this));
		this.HAMMER.on('panend', this.onTouchPanEnd.bind(this));
		this.HAMMER.on('singletap', this.onTap.bind(this));

		this.pinchPower = 3; // Zoom speed
	}

	// _____________________________________________________________________ Start

	onMouseLeave(event) {
		this.CONTROLLER.onInteractionMouseLeave(event);
	}

	onMouseMove(event) {
		//
		this.CONTROLLER.onInteractionMouseMove(event);
	}

	onMouseDown(event) {
		event.preventDefault();
		this.CONTROLLER.onInteractionMouseDown(event);
		this.positionPreviousX = event.clientX;
		this.positionPreviousY = event.clientY;
	}

	onTouchStart(event) {
		event.preventDefault();

		this.positionPreviousX = event.changedTouches[0].clientX;
		this.positionPreviousY = event.changedTouches[0].clientY;
	}

	// _____________________________________________________________________ Touch

	onTap(event) {
		if (this.CONTROLLER.onInteractionTap)
			this.CONTROLLER.onInteractionTap(event);
	}

	onTouchEnd(event) {
		// console.log(event);
		if (event.touches.length == 1) {
			this.positionPreviousX = event.touches[0].clientX;
			this.positionPreviousY = event.touches[0].clientY;
			// console.log(`x: ${this.positionPreviousX}  y: ${this.positionPreviousY}`);
		}
	}

	onTouchPinchStart(event) {
		this.pinchScale = this.getPointerDistance(event);
	}

	getPointerDistance(event) {
		const dx = event.pointers[0].clientX - event.pointers[1].clientX;
		const dy = event.pointers[0].clientY - event.pointers[1].clientY;
		return Math.sqrt(dx * dx + dy * dy);
	}

	onTouchPinch(event) {
		// debugger;
		// // if (event.additionalEvent === 'pinchin') {
		// 	this.CONTROLLER.onInteractionZoom(event.scale);
		// // }

		// if (event.additionalEvent === 'pinchout') {
		const newPinchScale = this.getPointerDistance(event);
		const pinchDelta = this.pinchScale - newPinchScale;
		this.CONTROLLER.onInteractionZoom(pinchDelta * this.pinchPower);
		this.pinchScale = newPinchScale;
		// }

		// Store
		this.positionPreviousX = event.changedPointers[0].clientX;
		this.positionPreviousY = event.changedPointers[0].clientY;
	}

	onTouchPinchEnd(event) {
		// Store
		this.positionPreviousX = event.changedPointers[0].clientX;
		this.positionPreviousY = event.changedPointers[0].clientY;

		// Stop one dragging finger at end of pinch acting as a pan
		this.disableTouch(250);
	}

	onTouchPanStart(event) {
		if (this.isTouchable === false) {
			return;
		}

		const x = event.changedPointers[0].clientX;
		const y = event.changedPointers[0].clientY;

		// Store
		this.positionPreviousX = x;
		this.positionPreviousY = y;

		// console.log('Pan started');
		// console.log(event);
	}

	onTouchPanMove(event) {
		if (this.isTouchable === false) {
			return;
		}

		const x = event.changedPointers[0].clientX;
		const y = event.changedPointers[0].clientY;

		this.CONTROLLER.onInteractionRotateHorizontal(x - this.positionPreviousX);
		this.CONTROLLER.onInteractionRotateVertical(y - this.positionPreviousY);

		// Store
		this.positionPreviousX = x;
		this.positionPreviousY = y;

		// console.log('Pan moved');
		// console.log(event);
		// console.log(`x: ${this.positionPreviousX}  y: ${this.positionPreviousY}`);
	}

	onTouchPanEnd(event) {
		// console.log('Pan ended');
	}

	disableTouch(duration) {
		this.isTouchable = false;
		setTimeout(this.ondisableTouchComplete.bind(this), duration);
	}

	ondisableTouchComplete() {
		this.isTouchable = true;
	}

	// _____________________________________________________________________ Wheel

	onWheel(event) {
		// console.log(event.deltaY);
		event.preventDefault();

		// Zoom
		// if (event.deltaY < 0.0) {
		const delta = event.wheelDelta
			? event.wheelDelta / 4
			: event.detail
			? -event.detail * 15
			: 0;
		this.CONTROLLER.onInteractionZoom(-delta);
		// } else if (event.deltaY > 0.0) {
		// 	this.CONTROLLER.onInteractionZoom(1.0);
		// }
	}
}
